import { AppFormSection } from '../ui/AppFormSection';
import { useLocalization } from '../lib/hooks/useLocalization';
import { Product } from '../processes/CMS/processes/management/pages/FindersAndProductsPage/lib/Product';

export function ImageAltTextFormItem(props) {
  const { label } = useLocalization().translations.unique.formItems.imageAltText;
  const { formItemProps, textFieldProps } = props;

  return (
    <AppFormSection
      formItemProps={{
        name: Product.IMAGE_ALT_TEXT,
        rules: [{ required: true }, { whitespace: true }],
        ...formItemProps,
      }}
      textFieldProps={{
        label,
        ...textFieldProps,
      }}
    />
  );
}
